
import { RevPicker, Variants } from '@ds/components/Picker'
import { IconEyes } from '@ds/icons/IconEyes'
import { IconSparkles } from '@ds/icons/IconSparkles'

import { tw } from '@core/tailwind'

import PickersList from '../PickersList'

const ICONS = {
  IconEyes,
  IconSparkles,
}

const HIGHLIGHTED_PICKERS_VARIANTS = {
  info: 'info',
  accent: 'accent',
}

export default {
  components: {
    PickersList,
    RevPicker,
  },

  props: {
    highlightedPickers: {
      type: Array,
      default: () => [],
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      pickers: [],
    }
  },

  computed: {
    pickersListClasses() {
      return tw`grid gap-2 grid-cols-${this.pickers.length}`
    },
  },

  watch: {
    selectedHighlightedPickers(newPicker, oldPicker) {
      if (newPicker !== oldPicker) {
        this.pickers = [...this.highlightedPickers]
      }
    },
  },

  created() {
    this.pickers = [...this.highlightedPickers]
  },

  mounted() {
    this.pickers = [...this.highlightedPickers]
  },

  methods: {
    variant(type) {
      if (type === HIGHLIGHTED_PICKERS_VARIANTS.info) {
        return Variants.Info
      }
      if (type === HIGHLIGHTED_PICKERS_VARIANTS.accent) {
        return Variants.Accent
      }

      return Variants.Default
    },

    pickersIcon(icon) {
      return ICONS[icon]
    },

    handlePickerClick(index) {
      this.$emit('highlighted-picker-click', index)
    },
  },
}
